<template>
    <div class="search-poet">
        <div class="poet-list">
            <PoetListItem v-for="poet in poets" :poet="changeFormat(poet)"/>
            <infinite-loading @infinite="search" ref="infiniteLoading" spinner="bubbles" :distance="250">
                <div slot="no-more"><i class="iconfont iconkong"></i>未找到相关信息~</div>
            </infinite-loading>
        </div>
    </div>
</template>

<script>
    import {SearchPoet} from "@/request/search";
    import InfiniteLoading from 'vue-infinite-loading';
    import PoetListItem from '@/components/PoetListItem.vue';
    export default {
        name: "PoetList",
        components:{
            InfiniteLoading,
            PoetListItem
        },
        data(){
            return{
                input:"",
                poets:[],
                pageNum:0,
                // 加载状态
                loading:false,
                noMore:false,
                infinity:null
            }
        },
        created(){
            // TODO 被挂载时也获取路由参数
            this.input = this.$route.params.input;
            // TODO 倘若当前未加载
            if (this.loading === false){
                // 初始化页数
                this.pageNum = 0;
                // 初始化变量
                this.poets = []
            }
        },
        methods:{
            /**
             * @author 孟祥龙
             * @Desc TODO 触发搜索，更新数据
             * @date 2021/5/11 14:39
             * @return
             */
            search($state){
                this.infinity = $state;
                this.loading = true;
                // 页数自增
                this.pageNum = this.pageNum + 1 ;
                SearchPoet({
                    searchContent:this.input,
                    pageNum:this.pageNum,
                    pageSize:20
                }).then(res => {
                    if (res.code === 200){
                        this.poets = this.poets.concat(res.data.list);
                        // 加载结束
                        $state.loaded();
                        this.loading = false;
                        // 没有更多
                        if (res.data.list.length === 0) {
                            this.noMore = true;
                            $state.complete();
                        }
                    }
                })
            },
            /**
             * @author 孟祥龙
             * @Desc TODO 调整格式
             * @date 2021/5/12 8:24
             * @return
             */
            changeFormat(poet){
                if (poet.highlight != null){
                    poet.intro = poet.highlight;
                }
                return poet;
            }
        }
    }
</script>

<style scoped>
    .search-poet{
        margin: 25px auto;
        width: 70%;
    }
</style>